import { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import axios from '../api/axios';

const REQUEST_VERIFICATION_URL = '/requestEmailVerification';
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const RequestVerification = () => {

    const emailRef = useRef();
    const errRef = useRef();

	const [email, setEmail] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [validEmail, setValidEmail] = useState(false);

	useEffect(() => {
        emailRef.current.focus();
    }, [])

    useEffect(() => {
        setErrMsg('');
        setValidEmail(EMAIL_REGEX.test(email));
    }, [email])


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(REQUEST_VERIFICATION_URL,
                JSON.stringify({ email }),
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            console.log(JSON.stringify(response?.data));
			setErrMsg("If there's an unverified account with that address, you'll receive a verification email shortly.");
            errRef.current.focus();
        } catch (err) {
			console.log(err);
			console.log(`err.response?.status: ${err.response?.status}`);
            if ((!err?.response) || (err.response?.status === 500)) {
                setErrMsg('Our apologies, but we\'re experiencing technical difficulties.');
            } else if (err.response?.status === 429) {
                setErrMsg('You\'ve exceeded the maximum number of requests. Please wait one hour, and try again.');
            } else {
				setErrMsg("If there's an unverified account with that address, you'll receive a verification email shortly.");
            }
            errRef.current.focus();
        }
    }

    return (

        <section>
			<h1>Request Verification</h1>
			<form onSubmit={handleSubmit}>
				<label htmlFor="email">Email:</label>
				<input
					type="text"
					id="email"
					ref={emailRef}
					autoComplete="off"
					onChange={(e) => setEmail(e.target.value)}
					value={email}
					required
				/>
				 <button disabled={validEmail ? false : true}>Request verification</button>
			</form>
            <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
			<nav>
				<Link to="/register">Home</Link>
				<Link to="/register">Sign up</Link>
				<Link to="/login">Log in</Link>
			</nav>
        </section>

    )
}

export default RequestVerification
